import {
  AuthErrorKind,
  ChangeEmailErrorKind,
  ChangePasswordErrorTypes,
  ReauthErrorKind,
} from '@griply/types';
import { ImageUploadErrorKind } from 'shared/types/image-upload-error';

// Outcomes a form already renders; an `unknown` kind is reported where it is thrown.
const expectedMutationErrors = new Set<string>([
  ...Object.values(AuthErrorKind).filter(
    (kind) => kind !== AuthErrorKind.Unknown,
  ),
  ...Object.values(ChangeEmailErrorKind).filter(
    (kind) => kind !== ChangeEmailErrorKind.Unknown,
  ),
  ChangePasswordErrorTypes.WrongPassword,
  ChangePasswordErrorTypes.WeakPassword,
  ReauthErrorKind.WrongPassword,
  ReauthErrorKind.Cancelled,
  // Refused before the upload; the image picker says the file is too large
  ImageUploadErrorKind.TooLarge,
]);

export const isExpectedMutationError = (error: unknown): boolean => {
  const kind = (error as { kind?: unknown } | null)?.kind;

  return typeof kind === 'string' && expectedMutationErrors.has(kind);
};
